import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown() {
  const [target, setTarget] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    axios
      .get(`${API}/settings/public`)
      .then((r) => {
        if (r.data.launch_date) setTarget(new Date(`${r.data.launch_date}T09:00:00`).getTime());
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!target) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) return null;
  const diff = target - now;
  if (diff <= 0) {
    return (
      <div
        className="inline-flex flex-wrap items-center gap-3 bg-honey text-forest rounded-2xl px-6 py-4"
        data-testid="launch-live-chip"
      >
        <span className="font-display text-2xl font-semibold">We're live! 🐝</span>
        <span className="text-sm text-forest/70">ApiaryKeeper has launched — grab it below.</span>
      </div>
    );
  }

  const units = [
    { label: "days", value: Math.floor(diff / 86400000) },
    { label: "hours", value: pad(Math.floor((diff / 3600000) % 24)) },
    { label: "minutes", value: pad(Math.floor((diff / 60000) % 60)) },
    { label: "seconds", value: pad(Math.floor((diff / 1000) % 60)) },
  ];

  return (
    <div
      className="inline-flex items-center gap-5 sm:gap-7 bg-bone/5 backdrop-blur border border-bone/15 rounded-2xl px-6 py-4"
      data-testid="launch-countdown"
    >
      <span className="text-[10px] uppercase tracking-[0.25em] text-honey">Full launch in</span>
      {units.map((u) => (
        <span key={u.label} className="text-center" data-testid={`countdown-${u.label}`}>
          <span className="block font-display text-2xl sm:text-3xl font-semibold text-bone leading-none tabular-nums">
            {u.value}
          </span>
          <span className="block text-[9px] uppercase tracking-[0.2em] text-bone/40 mt-1">{u.label}</span>
        </span>
      ))}
    </div>
  );
}
